import styled from "styled-components";
interface props {
  active: boolean;
}

export const IncidentGrid = styled.div.attrs({})`
  display: flex;
  max-height: 100vh;
`;
interface SideBarProps {
  show?: boolean;
}
export const Sidebar = styled.div.attrs({})<SideBarProps>`
  height: 100vh;
  background-color: var(--primaryPurpleMain);
  width: 320px;
  padding: 2rem 1.5rem 2rem 1.5rem;
  display: flex;
  flex-direction: column;
  @media screen and (max-width: 1024px) {
    width: 250px;
    padding: 2rem 0.7rem;
  }
  @media screen and (max-width: 900px) {
    display: none;
  }
`;
export const NavItemContainer = styled.div`
  margin-top: 3.5rem;
`;
export const AdminNavItemContainer = styled.div`
  margin-top: 5rem;
`;
export const LogoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Content = styled.div.attrs({})`
  max-height: 100vh;
  overflow-y: scroll;
  overflow-x: hidden;
  flex: 1;
  padding: 3rem 2rem 3rem 2rem;
`;

export const NavItem = styled.div.attrs({
  className: "px-4 py-3 flex",
})<props>`
  background-color: ${(props) =>
    props.active ? "var(--main-purple-light)" : ""};
  color: ${(props) => (props.active ? "white" : "var(--input_text_color)")};
  font-size: 1rem;
  cursor: pointer;
`;

export const BottomNav = styled.div.attrs({
  className: "flex items-end",
})`
  flex: 1;
`;

export const HideOnDesktop = styled.div.attrs({})`
  display: none;
  @media screen and (max-width: 900px) {
    display: block;
  }
`;
